import { useQuery } from "@tanstack/react-query";
import {
  attemptShowErrorsInSnackbar,
  useSnackbarActionContext,
} from "../context/SnackbarContext";
import GatewayService from "../services/GatewayService";
import UsersService from "@velocity-ehs/user-utils-module";
import { ApplicationRelationship } from "./useGetPolicies";

interface RoleQuery {
  items: Array<{
    editableByUser: boolean;
    id: string;
    name: string;
    description: string;
    applicationRelationship: ApplicationRelationship;
  }>;
}

function useGetCustomerRole(roleId: string) {
  const { showSnackbar } = useSnackbarActionContext();
  const { filter } = formatParams(roleId);

  const result = useQuery<RoleQuery>({
    queryKey: ["customerRole", roleId],
    queryFn: () =>
      GatewayService.getCustomerRole(UsersService.customer.id, filter),
    retry: false,
    enabled: !!roleId,
    onError: (error) => {
      attemptShowErrorsInSnackbar(showSnackbar, error);
    },
  });

  return {
    ...result,
    role: result.data?.items[0] || undefined,
  };
}

function formatParams(roleId: string) {
  const filter = {
    and: {
      id: roleId,
    },
  };

  return { filter };
}

export { useGetCustomerRole };
